import {Assert} from "common/Assert";

export const Ascii = new function() {

    function isUppercaseLetter( charCode ){
        Assert.checkArgumentType( charCode, "number" );
        return charCode >= 65 && charCode <= 90;
    }

    function isLowercaseLetter( charCode ){
        Assert.checkArgumentType( charCode, "number" );
        return charCode >= 97 && charCode <= 122;
    }

    return {
        /**
         * checks a charcode to be a Letter
         * @param {Number} charCode
         * @return {Boolean}
         */
        isLetter: ( charCode ) => {
            return isLowercaseLetter(charCode) || isUppercaseLetter(charCode);
        },
        isUppercaseLetter: isUppercaseLetter,
        isLowercaseLetter: isLowercaseLetter
    }
};
